import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Carousel from 'react-bootstrap/Carousel';
import ExampleCarouselImage from './ExampleCarouselImage';
import trek from '../images/HomeBanner.jpeg';
import trek1 from '../images/trek2.jpg';
import trek2 from '../images/trek3.jpg';

function NoTransitionExample() {
  return (
    <Carousel slide={false} style={{ height: '' }}>
      <Carousel.Item>
        <ExampleCarouselImage imageSrc={trek} altText="First slide" />
        <Carousel.Caption>
          <h1>Welcome To The Challenge Of Everest</h1>
          {/* Button for "How to Play Game" linking to GameInfo page */}
          <Link to="/GameInfo" className="game-button">
            How to Play Game
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <ExampleCarouselImage imageSrc={trek1} altText="Second slide" />
        <Carousel.Caption>
          <h1>Welcome To The Challenge Of Everest</h1>
          {/* Button for "How to Play Game" linking to GameInfo page */}
          <Link to="/GameInfo" className="game-button">
            How to Play Game
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <ExampleCarouselImage imageSrc={trek2} altText="Third slide" />
        <Carousel.Caption>
          <h1>Welcome To The Challenge Of Everest</h1>
          {/* Button for "How to Play Game" linking to GameInfo page */}
          <Link to="/GameInfo" className="game-button">
            How to Play Game
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default NoTransitionExample;
